import React, { ChangeEvent, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Dialog, DialogHeader, DialogBody } from "@material-tailwind/react";
import {
  addCategory,
  getAllCategories,
} from "../../../utils/apis/func";
import { useAppDispatch, useAppSelector } from "../../../utils/redux/hooks";
import { addcategories, addisLoading } from "../../../utils/redux/mainSlice";
import { RootState } from "../../../utils/redux/store";
import { MdDeleteOutline, MdEdit } from "react-icons/md";
import axios from "axios";

const AddCategory = () => {
  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [editSelected, seteditSelected] = useState<string>("");
  const [editName, seteditName] = useState<string>("");
  const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);
  const [temporaryURL, setTemporaryURL] = useState<string | null>(null);
  const [faqData, setfaqData] = useState({ name: "", value: "", imageURL: "" });
  const [isLoading, setisLoading] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const categories = useAppSelector((store: RootState) => store.user.categories);

  useEffect(() => {
    const fetchCategories = async () => {
      dispatch(addisLoading(true));
      const res = await getAllCategories("");
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addcategories((res as any).data.data));
      }
      dispatch(addisLoading(false));
    };

    fetchCategories();
  }, [dispatch]);

  const clearImage = () => {
    setSelectedImageFile(null);
    setTemporaryURL(null);
    setfaqData((current) => ({ ...current, imageURL: "" }));
  };
  const handleOpen = () => {
    clearImage();
    setOpen(!open);
  };
  const handleOpenEdit = () => {
    clearImage();
    setOpenEdit(!openEdit);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setfaqData({ ...faqData, [name]: value });
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedImageFile(file);
      setTemporaryURL(URL.createObjectURL(file));
      uploadFile(file);
    }
  };

  const uploadFile = async (image: File) => {
    setisLoading(true);
    dispatch(addisLoading(true));
    const formData = new FormData();
    formData.append("profile-picture", image);
    formData.append("folder", "services");

    try {
      const response = await axios.post(
        "https://api.pureworker.com/api/upload",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status === "success") {
        setfaqData((prevData) => ({
          ...prevData,
          imageURL: response.data.url,
        }));
        toast.success("Image uploaded successfully");
      } else {
        toast.error("Failed to upload image");
      }
    } catch (error) {
      console.error("Error uploading file", error);
      toast.error("Error uploading file");
    } finally {
      dispatch(addisLoading(false));
      setisLoading(false);
    }
  };

  const handleAddCategory = async () => {
    if (!faqData.name.trim()) {
      toast.warn("Enter a category name");
      return;
    }
    if (!faqData.imageURL) {
      toast.warn("Please select and upload an image first");
      return;
    }

    setisLoading(true);

    const res = await addCategory({
      name: faqData.name.trim(),
      value: faqData.name.trim(),
      imageURL: faqData.imageURL,
    });

    if (res?.status === 200 || res?.status === 201) {
      const latest = await getAllCategories("");
      if (latest?.status === 200) dispatch(addcategories((latest as any).data.data));
      toast.success("New Category Added Successfully");
      setOpen(false);
      setfaqData({ name: "", value: "", imageURL: "" });
      setTemporaryURL(null);
    } else {
      toast.error("Failed to add category");
    }
    setisLoading(false);
  };

  const handleEditCategory = async (id: string) => {
    if (!editName.trim()) {
      toast.warn("Enter a category name");
      return;
    }
    if (selectedImageFile && !faqData.imageURL) {
      toast.warn("Please wait for the image to upload first");
      return;
    }

    setisLoading(true);

    const reqBody = {
      id,
      name: editName.trim(),
      value: editName.trim(),
      ...(faqData.imageURL && { imageURL: faqData.imageURL }),
    };

    const res = await addCategory(reqBody);
    if (res?.status === 200 || res?.status === 201) {
      dispatch(addcategories(categories.map((category) =>
        (category._id || category.id) === id ? { ...category, ...reqBody } : category
      )));
      toast.success("Category Edited Successfully");
      setOpenEdit(false);
      setTemporaryURL(null);
    } else {
      toast.error("Failed to edit category");
    }
    setisLoading(false);
  };

  const handleDelete = async (id: string) => {
    if (isLoading) return;
    setisLoading(true);
    const res = await addCategory({ id, disabled: true });
    if (res?.status === 200 || res?.status === 201) {
      dispatch(addcategories(categories.filter((category) => (category._id || category.id) !== id)));
      toast.success("Category Deleted Successfully");
    } else {
      toast.error("Failed to delete category. Please try again.");
    }
    setisLoading(false);
  };

  return (
    <div>
      <p className="text-[#88087B] font-roboto text-3xl font-medium leading-normal px-6">
        Services
      </p>
      <div className="px-3">
        <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-2 border-b-2 border-[#000] w-fit pl-4 pr-10">
          Add Category
        </p>
      </div>
      <div className="px-4">
        <p className="text-[#000] font-roboto text-lg leading-normal mt-2">
          A section to add categories and images of the categories of services
          offered
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-3">
        {categories?.map((item) => (
          <div
            key={item?.id || item?._id}
            className="border rounded-md p-3 relative shadow-sm bg-white"
          >
            <div className="w-full h-40 overflow-hidden flex justify-center items-center bg-gray-200">
              <img
                src={item?.imageURL || item?.image}
                alt={item?.name}
                className="object-cover w-full h-full"
              />
            </div>
            <p className="text-[#000] font-roboto text-lg font-medium leading-normal mt-2">
              {item?.name}
            </p>
            <div className="absolute top-2 right-2 flex space-x-2">
              <button
                type="button"
                aria-label={`Edit ${item?.name}`}
                disabled={isLoading}
                className="cursor-pointer bg-[#F5F5F5] rounded-md p-0.5 hover:bg-lightBlue-500 hover:p-4 transition duration-300 ease-in-out"
                onClick={() => {
                  seteditSelected(item?.id || item?._id);
                  seteditName(item?.name || "");
                  handleOpenEdit();
                }}
              >
                <MdEdit size={24} />
              </button>
              <button
                type="button"
                aria-label={`Delete ${item?.name}`}
                disabled={isLoading}
                className="cursor-pointer bg-[#FF0000] rounded-md p-0.5 hover:bg-lightBlue-500 hover:p-4 transition duration-300 ease-in-out"
                onClick={() => handleDelete(item?.id || item?._id)}
              >
                <MdDeleteOutline size={24} />
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="ml-3">
        <button
          onClick={handleOpen}
          className="bg-[#F5F5F5] border border-gray-400 hover:bg-gray-200 text-[#000] font-roboto text-lg py-2 px-4 rounded-md shadow-sm"
        >
          + Add Category
        </button>
      </div>
      <Dialog open={open} handler={handleOpen}>
        <DialogHeader>Add New Category</DialogHeader>
        <DialogBody>
          <section className="flex flex-col lg:flex-row w-full gap-16 px-3 lg:px-6">
            <div className="flex flex-col gap-7 w-full font-roboto text-sm font-normal leading-normal">
              <div className="mb-0">
                <label
                  htmlFor="name"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Category Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={faqData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  required
                />
              </div>
              <div className="mb-0">
                <label
                  htmlFor="image"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Category Image
                </label>
                <input
                  id="image"
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
                />
              </div>
              {temporaryURL && (
                <div className="mt-2">
                  <img
                    src={temporaryURL}
                    alt="Temporary Preview"
                    className="w-24 h-24 object-cover"
                  />
                </div>
              )}
              <button
                onClick={handleAddCategory}
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                disabled={isLoading}
              >
                {isLoading ? "Adding..." : "Add Category"}
              </button>
            </div>
          </section>
        </DialogBody>
      </Dialog>
      <Dialog open={openEdit} handler={handleOpenEdit}>
        <DialogHeader>Edit Category</DialogHeader>
        <DialogBody>
          <section className="flex flex-col lg:flex-row w-full gap-16 px-3 lg:px-6">
            <div className="flex flex-col gap-7 w-full font-roboto text-sm font-normal leading-normal">
              <div className="mb-0">
                <label
                  htmlFor="editName"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Category Name
                </label>
                <input
                  type="text"
                  id="editName"
                  name="editName"
                  value={editName}
                  onChange={(e) => seteditName(e.target.value)}
                  placeholder="Edit Name"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  required
                />
              </div>
              <div className="mb-0">
                <label
                  htmlFor="editImage"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Category Image
                </label>
                <input
                  id="editImage"
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
                />
              </div>
              {temporaryURL && (
                <div className="mt-2">
                  <img
                    src={temporaryURL}
                    alt="Temporary Preview"
                    className="w-24 h-24 object-cover"
                  />
                </div>
              )}
              <button
                onClick={() => handleEditCategory(editSelected)}
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                disabled={isLoading}
              >
                {isLoading ? "Editing..." : "Edit Category"}
              </button>
            </div>
          </section>
        </DialogBody>
      </Dialog>
    </div>
  );
};

export default AddCategory;
